export default __webpack_public_path__ + "static/media/MX.d3b89e27.svg";